<template>
  <div class="overflow-auto disable-scrollbars button-group-wrapper overflow-lg-visible">
    <b-button-group class="d-flex justify-content-between">
      <b-button v-for="(btn, index) in buttons" :key="index"
                :class="['button-group-item',
                          'btn-outline-orange',
                          'rounded',
                          {
                            'ml-1': index !== 0 ,
                            'active': selected.includes(btn),
                          },
                          btn.class || '']"
                variant="outline" type="radio" name="reportType"
                @click.prevent="selectButton(btn)">
        <span
          class="button-group-item-name"
          :class="btn.shortName ? 'd-none d-lg-block': ''"> {{btn.name}}</span>
        <span v-if="btn.shortName"
          class="button-group-item-name d-lg-none"> {{btn.shortName}}</span>
      </b-button>
    </b-button-group>
  </div>
</template>

<script>

export default {
  name: 'ButtonGroup',
  props: {
    value: null,
    buttons: {
      type: Array,
      required: true,
      validator(entries) {
        return entries.length > 0
        && entries.every(obj => Object.prototype.hasOwnProperty.call(obj, 'name')
            && Object.prototype.hasOwnProperty.call(obj, 'value'));
      },
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: [],
    };
  },
  computed: {
    selectedValues() {
      if (this.multiple) {
        return this.buttons
          .filter(button => this.selected.includes(button))
          .map(button => button.value);
      }

      return this.selected.length ? this.selected[0].value : null;
    },
  },
  methods: {
    selectButton(button) {
      if (!this.multiple) {
        this.selected = [button];
      } else if (this.selected.includes(button)) {
        this.selected.splice(this.selected.indexOf(button), 1);
      } else {
        this.selected.push(button);
      }

      this.$emit('input', this.selectedValues);
      this.$emit('change', this.selectedValues);
    },
    setSelected() {
      if (this.value === undefined) return;

      if (this.multiple) {
        this.selected = this.buttons.filter(button => this.value.includes(button.value));
        return;
      }

      this.selected = this.buttons.filter(button => button.value === this.value);
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.setSelected();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-outline-orange {
  color: black;
  border-color: $bg-light;
}

.btn-outline-orange:not(:disabled):not(.disabled):active,
.btn-outline-orange:not(:disabled):not(.disabled).active,
.show > .btn-outline-orange.dropdown-toggle {
  color: #fff;
  background-color: $bg-light;
  border-color: $bg-light;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

</style>
